export const environment = {
  production: true,
  buildId: '3962267102724031',
  configFile: 'config.json',
};
